import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoSecondary from '../assets/logos/logo-secondary-yellow.png';

const Footer: React.FC = () => {
  return (
    <div className="footer">
      <div className="footer-left">
        <img src={logoSecondary} alt="Revealer Logo" className="footer-logo" />
        <p>&copy; Revealer 2026</p>
        <Link to="/terms">Terms & Privacy</Link>
      </div>
      <div className="footer-right">
        <p>All Rights Reserved</p>
      </div>
    </div>
  );
};

export default Footer;